import { Firestore } from '../../config/firebase';
import { collection, doc, getDoc, getDocs, query, where, orderBy, updateDoc, setDoc } from 'firebase/firestore';

const employeesDb = () => {
  const add = _employeeInfo => {
    return false
    // TODO: Implement add functionality with modular API
  }

  // TODO: Move to server function to check permission
  const archive = async employeeId => {
    const employeeRef = doc(Firestore, 'employees', employeeId);
    return setDoc(employeeRef, { active: false }, { merge: true });
  }

  const update = async (employeeId, employeeInfo) => {
    delete employeeInfo.email;
    delete employeeInfo.password;
    const employeeRef = doc(Firestore, 'employees', employeeId);
    return updateDoc(employeeRef, employeeInfo);
  }

  const findOne = async employeeId => {
    const employeeRef = doc(Firestore, 'employees', employeeId);
    return getDoc(employeeRef);
  }

  const findByUserId = async userId => {
    const employeesRef = collection(Firestore, 'employees');
    const q = query(employeesRef, where('userId', '==', userId));
    return getDocs(q);
  }

  const findAll = ({ companyId, teamId, active = true }) => {
    const employeesRef = collection(Firestore, 'employees');
    let q = query(
      employeesRef,
      where('companyId', '==', companyId),
      where('active', '==', active),
      orderBy('name')
    );

    if (teamId) {
      q = query(q, where('teamId', '==', teamId));
    }

    return q;
  }

  const toggleStatus = employee => {
    if (!employee.active) {
      return unarchive(employee.id);
    } else {
      return archive(employee.id);
    }
  }

  // TODO: Move to server function to check permissions
  const unarchive = async employeeId => {
    const employeeRef = doc(Firestore, 'employees', employeeId);
    return setDoc(employeeRef, { active: true }, { merge: true });
  }

  return Object.freeze({
    add,
    archive,
    update,
    findOne,
    findAll,
    findByUserId,
    toggleStatus,
    unarchive
  })
}

const Employees = employeesDb();

export { Employees }
